<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      subscription: {
        days: 0,
        hours: 0,
        minutes: 0,
        active: false,
      },
    };
  },
  mounted() {
    // Initial calculation
    this.getRemainingTime();
    // Update every minute
    this._timerInterval = setInterval(() => {
      this.getRemainingTime();
    }, 60000);
  },
  beforeDestroy() {
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
    }
  },
  methods: {
    isSubscriptionPeriod(p = undefined) {
      const product = p || this.product;
      if (!product || !product.subscription || !product.subscription.startDate || !product.subscription.endDate) {
        return false;
      }
      const now = DateTime.now();
      // const maxCountdownDuration = this.$config.common.maxCountdownDuration || 30; // days
      const endDate = DateTime.fromISO(product.subscription.endDate);
      const startDate = DateTime.fromISO(product.subscription.startDate);

      // Check if dates are valid
      if (!endDate.isValid || !startDate.isValid) {
        console.warn('Invalid date format in subscription', { startDate: product.subscription.startDate, endDate: product.subscription.endDate });
        this.subscription.active = false;
        return false;
      }
      this.subscription.active = now >= startDate && now <= endDate;
      // this.subscription.active = now <= endDate; // or only look for the end date

      return this.subscription.active;
    },
    /**
     * Returns the start of the subscription period in a localized string
     * eg : Novembre 2024, September 2025
     */
    getSuscriptionMonthPeriod(p = undefined) {
      const product = p || this.product;
      const locale = this.$lang;
      if (product && (product.subscription || product.launchDate)) {
        const launchDate = product.subscription ? product.subscription.startDate : product.launchDate;
        const startDate = DateTime.fromISO(launchDate);
        const label = startDate.setLocale(locale).toLocaleString({ month: 'long', year: 'numeric' });
        return label;
      }
      return ' ';
    },
    getRemainingTime(p = undefined) {
      const product = p || this.product;
      if (!this.isSubscriptionPeriod(product)) {
        return { days: 0, hours: 0, minutes: 0 };
      }
      const now = DateTime.now();
      const endDate = DateTime.fromISO(product.subscription.endDate);
      const diff = endDate.diff(now, ['days', 'hours', 'minutes']).toObject();
      const days = Math.floor(diff.days || 0);
      const hours = Math.floor(diff.hours || 0);
      const minutes = Math.floor(diff.minutes || 0);
      this.subscription.days = days;
      this.subscription.hours = hours;
      this.subscription.minutes = minutes;
      return { days, hours, minutes };
    },
  },
};
</script>
